module.exports = __webpack_public_path__ + "img/1557614111226929153.afe56d69.png";